import { get, put, post, del } from '@/request/http.js';

/**
 * Ajax加载数据
 */
export const ajaxData = (url, data) => {
  return post(
    url,
    data
  )
}
